import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { Knife, Type } from '@utils/tool'

import { getUrl } from './useBlog'

export const getBlogId = (pathname) => {
  let id = ''
  if (pathname.search(/^\/blog-detail\/.*-b-\d+.html/i) > -1) {
    id = pathname
      .match(/-b-\d+.html/)[0]
      .substring(3)
      .split('.')[0]
  }
  return id
}

const defaultData = {
  alsoLike: [],
  content: '',
  title: '',
  imageDetailPc: '',
  createTime: '',
  metaTitle: 'blog',
  origin: ''
}

export const useBlogDetail = (props?: ServerFC<any>) => {
  const navigate = useNavigate()

  const ssrData = { ...defaultData, ...props.pageData } || defaultData
  // m跳
  const jumpToM = (data: any) => {
    const toUrl = getUrl(data)
    toUrl && navigate(toUrl)
  }

  return {
    dataInfo: ssrData,
    jumpToM
  }
}
